const common = require('./common');
const constructor = require('./constructor');
const date = require('./date');
const html = require('./html');

module.exports = {
    ...common,
    ...constructor,
    ...date,
    ...html,
};
